import { State as UserState } from "./modules/user"
import { State as PermissionState } from "./modules/permission"
import { State as AppState } from "./modules/app"
import { State as commonState } from "./modules/common"
// import { PROPERTY_GROUP } from "@/types/base"

export interface State {
    user: UserState
    permission: PermissionState
    app: AppState
    common: commonState
}

export default {
    token: (state: State) => state.user.token,
    name: (state: State) => state.user.name,
    currentUser: (state: State) => state.user,
    permissionRoutes: (state: State) => state.permission.routes,
    isCollapse: (state: State) => state.app.sidebar.isCollapse,
    allUser: (state: State) => state.user.allUser,
    allDepart: (state: State) => state.user.allDepart,
    orgUser: (state: State) => state.user.orgUser,
    org: (state: State) => state.user.org,
    emailAll: (state: State) => state.user.emailAll,
    groupAll: (state: State) => state.user.groupAll,
    noPermission: (state: State) => state.user.noPermission,
    uid: (state: State) => state.user.uid,
    is_account_admin: (state: State) => state.user.is_account_admin,
    is_email_admin: (state: State) => state.user.is_email_admin,
    version: (state: State) => state.common.version,
    isIT: (state: State) => {
        return ["it", "property_admin"].includes(state.user.property_role)
    },
    havePreUser: (state: State) => state.user.havePreUser,
    allOrgs: (state: State) => state.user.allOrgs,
    isAdmin: (state: State) =>
        Array.isArray(state.user.roles) && state.user.roles.includes("admin")
}
